"use client";

import React from "react";
import styled from "styled-components";
import { blockPadding, Box } from "@motorata/base-ui.components.atoms._atoms";
import TextHTML from "@motorata/base-ui.components.atoms.text-html";
import { H1 } from "@motorata/base-ui.components.atoms.typography";

const SeoTextSection = ({ title, content }: {
  title: string
  content?: string
}) => {
  return (
    <Wrapper>
      <H1>{title}</H1>
      {content && <TextHTML type="secondary" content={content} />}
    </Wrapper>
  );
};

export default SeoTextSection;

const Wrapper = styled(Box)`
  ${blockPadding};
  max-width: 1300px;
  margin: 0 auto;
`
